// import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { EDITOR } from '../../../constants'
import { createBoard } from '../../../store/actions/boards'
import { createFolder } from '../../../store/actions/folders'
import { userSelector } from '../../../store/selectors/baseSelectors'
import { hasMouseSelector } from '../../../store/selectors/selectors'
import {
  sidebarFolderSelector,
  sidebarSectionSelector
} from '../../../store/selectors/sidebarSelectors'

export default connect(
  state => {
    const user = userSelector(state)
    const folder = sidebarFolderSelector(state)
    return {
      anon: user.isEmpty || user.isAnonymous,
      section: sidebarSectionSelector(state),
      folderId: folder && folder.id,
      hasMouse: hasMouseSelector(state),
      canCreate: !folder || sidebarFolderSelector(state).access >= EDITOR
    }
  },
  {
    createBoard,
    createFolder
  }
)
